import api from './api';

class ImportExportService {
  async downloadTemplate(institutionType = 'microfinance') {
    const response = await api.get('/data/template', {
      params: { institution_type: institutionType },
      responseType: 'blob',
    });
    return response.data;
  }

  async exportData() {
    const response = await api.get('/data/export', {
      responseType: 'blob',
    });
    return response.data;
  }

  async importData(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/data/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
}

export default new ImportExportService();
